import { fetchApiGateway } from "@nova/fetch-api-gateway"

// Dehaze doesn't change scene selection, so there's no dehaze-specific index raster.
export const indexCogIdForCloudFree = (cloudFree: boolean) =>
    cloudFree ? "cloudfree_index.cog.tif" : "basic_index.cog.tif"

// Standard Web Mercator slippy-tile math, kept fractional so the pixel offset within the tile is one multiply away.
export function lngLatToTileFraction(lng: number, lat: number, z: number) {
    const scale = Math.pow(2, z)
    const x = ((lng + 180) / 360) * scale
    const latRad = (lat * Math.PI) / 180
    const y = ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * scale
    return { x, y }
}

// Mirrors OrthomosaicLayer's query construction exactly so this hits the browser's HTTP cache for already-fetched tiles.
export async function fetchTileImageData(
    orgId: string,
    projectId: string,
    flightId: string,
    isDemo: boolean,
    cloudFree: boolean,
    z: number,
    x: number,
    y: number
): Promise<ImageData | undefined> {
    const tilesize = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 512 : 256
    const options: Record<string, string> = { tilesize: String(tilesize) }
    if (isDemo) options.isDemo = "true"
    options.cogId = indexCogIdForCloudFree(cloudFree)
    options.source = "satellite"

    const res = await fetchApiGateway(
        "get /org/:orgId/project/:projectId/flight/:flightId/tile/:z/:x/:y",
        {
            params: { orgId, projectId, flightId, z, x, y },
            query: new URLSearchParams(options).toString(),
            headers: { Accept: "image/png" },
            rawResponse: true,
        }
    )
    if (!res.ok) return undefined
    const blob = await res.blob()
    const bitmap = await createImageBitmap(blob)

    const canvas = document.createElement("canvas")
    canvas.width = bitmap.width
    canvas.height = bitmap.height
    const ctx = canvas.getContext("2d")
    if (!ctx) return undefined
    ctx.drawImage(bitmap, 0, 0)
    return ctx.getImageData(0, 0, bitmap.width, bitmap.height)
}
